export default "__VITE_ASSET__AGMlS3gT__"